var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4688 2C17.8125 2 18.5 3.625 17.5312 4.5625L12.5 9.625V16.5312C12.5 17.7812 11.0625 18.4062 10.0938 17.75L8.09375 16.25C7.71875 15.9375 7.5 15.5 7.5 15V9.625L2.4375 4.5625C1.46875 3.625 2.15625 2 3.5 2H16.4688ZM11 9L16.5 3.5H3.5L9 9V15L11 16.5V9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrowLeftIcon.10c59d540cfce54dc16917a329b0103d.svg";
export { ForwardRef as ReactComponent };